var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.75,
    fill: "#1671D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8137 13.1168C26.2151 12.7377 26.8475 12.7555 27.2267 13.1569C27.6059 13.5583 27.5881 14.1907 27.1867 14.57L16.2678 24.8825C15.9065 25.2236 15.3551 25.2453 14.9699 24.9469L14.8947 24.8825L10.8137 21.028C10.4122 20.6487 10.3944 20.0164 10.7736 19.6149C11.1528 19.2135 11.7852 19.1949 12.1867 19.5739L15.5812 22.7799L25.8137 13.1168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVerified);
export default __webpack_public_path__ + "static/media/check-verified.13a23ca2ae1c2c4d8d2cc00c3895a2af.svg";
export { ForwardRef as ReactComponent };